var version = {
    "name":      "dativery",
    "buildDateCode": "20260407-100635",
    "buildDate": "Tue Apr 07 2026 10:06:35 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260407-100635",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;